<script>
    import Share from './Share.svelte';
  
    export let params
  
  
  </script>
  
  {#key params.someParam}
    <Share link={params.link} /> 
  {/key}